import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faUnlockAlt, faUser } from '@fortawesome/free-solid-svg-icons';
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons';
// import {
//   faFacebookF,
//   faGithub,
//   faTwitter,
// } from '@fortawesome/free-brands-svg-icons';
import {
  Col,
  Row,
  Form,
  Container,
  InputGroup,
  Alert,
  Image,
} from 'react-bootstrap';
import { Formik } from 'formik';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useMutation } from 'react-query';
import zxcvbn from 'zxcvbn';
import { object, string, ref } from 'yup';
import { Routes } from '../routes';
// import BgImage from '../assets/img/illustrations/signin.svg';
import { signUp } from '../api/account';
import Preloader from '../components/Preloader';
import Button from '../components/Button';
import Card from '../components/Card';
import Logo from '../assets/images/Logo-printcart-new.svg';
import styles from '../assets/css/signup.module.css';

const PasswordField = (props) => {
  const { password, handleChange, errors, touched, focusField, setFocusField } =
    props;

  const passwordLength = password.length;

  const [pwShow, setPwShow] = React.useState(false);

  const isValid = password.match(
    /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})/
  );

  let strength = zxcvbn(password).score;

  if (!isValid) {
    switch (strength) {
      case 3:
        strength = 2;
        break;
      case 4:
        strength = 2;
        break;
      default:
    }
  }

  let strengthLabel = '';
  let strengthClassName = '';

  switch (strength) {
    case 0:
      strengthLabel = 'Weak';
      strengthClassName = 'passwordWeak';
      break;
    case 1:
      strengthLabel = 'Weak';
      strengthClassName = 'passwordWeak';
      break;
    case 2:
      strengthLabel = 'Medium';
      strengthClassName = 'passwordMedium';
      break;
    case 3:
      strengthLabel = 'Strong';
      strengthClassName = 'passwordStrong';
      break;
    case 4:
      strengthLabel = 'Strong';
      strengthClassName = 'passwordStrong';
      break;
    default:
      strengthLabel = '';
      strengthClassName = '';
  }

  return (
    <>
      <div>
        <Form.Label className="d-flex justify-content-between align-items-end">
          <div>Password</div>
          {password ? (
            <div className={`${styles.status} ${styles[strengthClassName]}`}>
              {strengthLabel}
            </div>
          ) : null}
        </Form.Label>
      </div>
      <InputGroup>
        <InputGroup.Text
          className={
            touched.password && errors.password && focusField !== 'password'
              ? styles.invalid
              : ''
          }
        >
          <FontAwesomeIcon icon={faUnlockAlt} />
        </InputGroup.Text>
        <Form.Control
          type={pwShow ? 'text' : 'password'}
          className={
            touched.password && errors.password && focusField !== 'password'
              ? styles.inputInvalid
              : ''
          }
          onFocus={() => setFocusField('password')}
          onBlur={() => setFocusField('')}
          placeholder="Password"
          value={password}
          name="password"
          onChange={(e) => {
            handleChange(e);
          }}
        />
        <Button
          variant="outline-ghost"
          className={`${
            touched.password && errors.password && focusField !== 'password'
              ? styles.invalid
              : ''
          } ${styles.showPassword}`}
          onClick={() => {
            setPwShow(!pwShow);
          }}
        >
          <FontAwesomeIcon icon={pwShow ? faEye : faEyeSlash} />
        </Button>
      </InputGroup>
      <div
        className={`${styles.strengthMeter} mt-2 ${
          passwordLength > 0 ? 'visible' : 'invisible'
        }`}
      >
        <div className={styles.strengthMeterFill} data-strength={strength} />
      </div>
      {errors.password && touched.password ? (
        <small style={{ color: 'red' }}>{errors.password}</small>
      ) : null}
    </>
  );
};

const Signup = () => {
  const { search } = useLocation();

  const getStarted = new URLSearchParams(search).get('get-started');

  const history = useHistory();

  const [showAlert, setShowAlert] = useState();

  const [focusField, setFocusField] = useState();

  const [pwType, setPwType] = React.useState('password');

  const { mutate, isLoading, error } = useMutation(signUp, {
    onError: () => {
      setShowAlert('error');
    },
    onSuccess: ({ data }) => {
      localStorage.setItem('_pc-t', data.data.access_token);

      const storesPath = getStarted
        ? `${Routes.StoreList.path}?get-started=true`
        : Routes.StoreList.path;

      history.push(storesPath);
    },
  });

  const initialValues = {
    name: '',
    email: '',
    password: '',
    pw_confirmation: '',
  };

  const onSubmit = async (values) => {
    const formData = {
      name: values.name,
      email: values.email,
      password: values.password,
    };

    mutate(formData);
  };

  const validate = object().shape({
    name: string().required('Required'),
    email: string().email(),
    password: string()
      .required('Please Enter your password')
      .matches(
        /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})/,
        'Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character'
      ),
    pw_confirmation: string().oneOf([ref('password'), null], 'Passwords must match'),
  });

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      enableReinitialize
      validationSchema={validate}
    >
      {({ handleSubmit, handleChange, values, errors, touched }) => (
        <main>
          <section className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
            <Container fluid>
              <p className="text-center">
                <Image src={Logo} height={60} className="mb-3" />
              </p>
              <Row className="justify-content-center">
                <Col
                  xs={12}
                  className="d-flex align-items-center justify-content-center"
                >
                  <div className="mb-4 mb-lg-0 bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                    <div className="text-center text-md-center mb-4 mt-md-0">
                      <h3 className="mb-0">Create your account</h3>
                    </div>
                    <Form className="mt-4" onSubmit={handleSubmit}>
                      {isLoading && <Preloader />}
                      {!isLoading && showAlert === 'success' && (
                        <Alert variant="success">Register successfull!</Alert>
                      )}
                      {!isLoading && showAlert === 'error' && (
                        <Alert variant="danger">
                          {/* {error?.response?.data?.error?.password &&
                            error?.response?.data?.error?.password[0]} */}
                          {error?.response?.data?.error?.email
                            ? error?.response?.data?.error?.email[0]
                            : error?.response?.data?.error?.password[0]}
                        </Alert>
                      )}
                      {!isLoading && showAlert === 'warning' && (
                        <Alert variant="danger">
                          Password and Confirm password not match!
                        </Alert>
                      )}
                      <Form.Group id="email" className="mb-4">
                        <Form.Label className="d-flex justify-content-between align-items-end">
                          <div>Name</div>
                          {errors.name && touched.name ? (
                            <div className={styles.status}>{errors.name}</div>
                          ) : null}
                        </Form.Label>
                        <InputGroup>
                          <InputGroup.Text
                            className={
                              touched.name && errors.name && focusField !== 'name'
                                ? styles.invalid
                                : ''
                            }
                          >
                            <FontAwesomeIcon icon={faUser} />
                          </InputGroup.Text>
                          <Form.Control
                            isInvalid={touched.name && errors.name}
                            onFocus={() => setFocusField('name')}
                            onBlur={() => setFocusField('')}
                            autoFocus
                            type="name"
                            placeholder="Name"
                            value={values.name}
                            name="name"
                            onChange={(e) => {
                              handleChange(e);
                            }}
                          />
                        </InputGroup>
                      </Form.Group>
                      <Form.Group id="email" className="mb-4">
                        <Form.Label className="d-flex justify-content-between align-items-end">
                          <div>Email</div>
                          {errors.email && touched.email ? (
                            <div className={styles.status}>{errors.email}</div>
                          ) : null}
                        </Form.Label>
                        <InputGroup>
                          <InputGroup.Text
                            className={
                              touched.email && errors.email && focusField !== 'email'
                                ? styles.invalid
                                : ''
                            }
                          >
                            <FontAwesomeIcon icon={faEnvelope} />
                          </InputGroup.Text>
                          <Form.Control
                            autoFocus
                            isInvalid={touched.email && errors.email}
                            onFocus={() => setFocusField('email')}
                            onBlur={() => setFocusField('')}
                            placeholder="example@company.com"
                            value={values.email}
                            name="email"
                            onChange={(e) => {
                              handleChange(e);
                            }}
                          />
                        </InputGroup>
                      </Form.Group>
                      <Form.Group id="password" className="mb-4">
                        <PasswordField
                          label="Password"
                          placeholder="Enter Password"
                          // onStateChanged={this.passwordChanged}
                          thresholdLength={7}
                          minStrength={3}
                          password={values.password}
                          handleChange={handleChange}
                          errors={errors}
                          touched={touched}
                          focusField={focusField}
                          setFocusField={setFocusField}
                        />
                      </Form.Group>
                      <Form.Group id="confirmPassword" className="mb-4">
                        <Form.Label className="d-flex justify-content-between align-items-end">
                          <div>Confirm Password</div>
                          {errors.pw_confirmation && touched.pw_confirmation ? (
                            <div className={styles.status}>
                              {errors.pw_confirmation}
                            </div>
                          ) : null}
                        </Form.Label>
                        <InputGroup>
                          <InputGroup.Text
                            className={
                              touched.pw_confirmation &&
                              errors.pw_confirmation &&
                              focusField !== 'pw_confirmation'
                                ? styles.invalid
                                : ''
                            }
                          >
                            <FontAwesomeIcon icon={faUnlockAlt} />
                          </InputGroup.Text>
                          <Form.Control
                            type={pwType}
                            className={
                              touched.pw_confirmation &&
                              errors.pw_confirmation &&
                              focusField !== 'pw_confirmation'
                                ? styles.inputInvalid
                                : ''
                            }
                            onFocus={() => setFocusField('pw_confirmation')}
                            onBlur={() => setFocusField('')}
                            placeholder="Confirm Password"
                            value={values.pw_confirmation}
                            name="pw_confirmation"
                            onChange={(e) => {
                              handleChange(e);
                            }}
                          />
                          <Button
                            variant="outline-ghost"
                            className={`${
                              touched.pw_confirmation &&
                              errors.pw_confirmation &&
                              focusField !== 'pw_confirmation'
                                ? styles.invalid
                                : ''
                            } ${styles.showPassword}`}
                            onClick={() => {
                              setPwType((val) => {
                                return val === 'password' ? 'text' : 'password';
                              });
                            }}
                          >
                            <FontAwesomeIcon
                              icon={pwType === 'password' ? faEye : faEyeSlash}
                            />
                          </Button>
                        </InputGroup>
                      </Form.Group>
                      {/* <FormCheck type="checkbox" className="d-flex mb-4">
                        <FormCheck.Input required id="terms" className="me-2" />
                        <FormCheck.Label htmlFor="terms">
                          I agree to the <Card.Link>terms and conditions</Card.Link>
                        </FormCheck.Label>
                      </FormCheck> */}
                      <Button
                        variant="primary"
                        type="submit"
                        className="w-100"
                        disabled={isLoading}
                      >
                        {isLoading ? 'Signing up ...' : 'Sign up'}
                      </Button>
                    </Form>

                    {/* <div className="mt-3 mb-4 text-center">
                      <span className="fw-normal">or</span>
                    </div>
                    <div className="d-flex justify-content-center my-4">
                      <Button
                        variant="outline-light"
                        className="btn-icon-only btn-pill text-facebook me-2"
                      >
                        <FontAwesomeIcon icon={faFacebookF} />
                      </Button>
                      <Button
                        variant="outline-light"
                        className="btn-icon-only btn-pill text-twitter me-2"
                      >
                        <FontAwesomeIcon icon={faTwitter} />
                      </Button>
                      <Button
                        variant="outline-light"
                        className="btn-icon-only btn-pil text-dark"
                      >
                        <FontAwesomeIcon icon={faGithub} />
                      </Button>
                    </div> */}
                    <div className="d-flex justify-content-center align-items-center mt-4">
                      <span className="fw-normal">
                        Already have an account?
                        <Card.Link
                          as={Link}
                          to={Routes.Signin.path}
                          className="fw-bold"
                        >
                          {' Login here '}
                        </Card.Link>
                      </span>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
        </main>
      )}
    </Formik>
  );
};

export default Signup;
